/**
 * Kind of property an object is (Typbestimmung: Stiegenhaus, Büro, Arztpraxis, …).
 *
 * Wire contract (Api ADR-0024): lowercase strings, `null` = not specified. The list is
 * fixed by the backend enum — keep the order in sync with `ObjectTypeCodes`.
 */
export const OBJECT_TYPES = [
  'stairwell',
  'office',
  'medicalpractice',
  'retail',
  'gastronomy',
  'industrial',
  'education',
  'parkinggarage',
  'other',
] as const;

export type ObjectType = (typeof OBJECT_TYPES)[number];

export function isObjectType(value: unknown): value is ObjectType {
  return typeof value === 'string' && (OBJECT_TYPES as readonly string[]).includes(value);
}

/** Normalizes a wire value (any casing, null/undefined) to a known type, or null. */
export function toObjectType(value?: string | null): ObjectType | null {
  const normalized = (value ?? '').toLowerCase();
  return isObjectType(normalized) ? normalized : null;
}

/** i18n key of the type label in the `objects` namespace. */
export function objectTypeLabelKey(type: ObjectType): string {
  return `objects:objectType.${type}`;
}
